var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "a",
    { staticClass: "ui-select u-row" },
    [
      _c("div", { staticClass: "u-flex cl-black" }, [
        _c("p", { staticClass: "label w5" }, [_vm._v(_vm._s(_vm.label))]),
        _vm._v(" "),
        _c("p", { staticClass: "value t12" }, [_vm._v(_vm._s(_vm.value))])
      ]),
      _vm._v(" "),
      _c("icon-dropdown", { staticClass: "cl-blue" })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }